import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FrontendCountdownTimerComponent } from './frontend-countdown-timer.component';

@NgModule({
  declarations: [FrontendCountdownTimerComponent],
  imports: [CommonModule],
  exports: [FrontendCountdownTimerComponent],
})
export class FrontendCountdownTimerModule { }
